import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ExamsApis from "../../api/ExamsApis";
import { Exam, ExamFilters } from "../../types/ExamType";

interface ExamsState {
  list: Exam[];
  loading: boolean;
  total: number;
  page: number;
  size: number;
  filters: Omit<ExamFilters, "page" | "size">;
}

const initialState: ExamsState = {
  list: [],
  loading: false,
  total: 0,
  page: 0,
  size: 10,
  filters: {},
};

export const fetchExams = createAsyncThunk(
  "exams/fetch",
  async (params: ExamFilters) => {
    const res = await ExamsApis.fetchExams(params);
    return res.data.data;
  }
);

const examsSlice = createSlice({
  name: "exams",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    },
    setPageSize(state, action) {
      state.size = action.payload;
      state.page = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExams.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExams.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.content;
        state.total = action.payload.totalElements;
      })
      .addCase(fetchExams.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters, setPage,setPageSize } = examsSlice.actions;
export default examsSlice.reducer;
